function sortAlphabetical(valueA: string, valueB: string) {
  if (!valueA) {
    return 1;
  }

  if (!valueB) {
    return -1;
  }

  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
}

export default sortAlphabetical;
